import { useState } from "react";
import { ColumnDef } from "../components/ColumnVisibilityPopover";
import {
	ColumnDefaults,
	getColumnVisibilityFromConfig,
	loadGridConfig,
	saveGridConfig,
	updateColumnVisibilityInConfig
} from "../utils/gridConfig";

export function useColumnVisibility(
	path: string[],
	columns: ColumnDef[]
): [Set<string>, (newVisible: Set<string>) => void] {
	const allIds = columns.map((c) => c.id);
	const alwaysVisibleIds = new Set(columns.filter((c) => c.alwaysVisible).map((c) => c.id));
	const newColumnIds = new Set(columns.filter((c) => c.isNew).map((c) => c.id));
	const columnDefaults: Record<string, ColumnDefaults> = Object.fromEntries(
		columns.map((c) => [c.id, { defaultVisible: c.defaultVisible, isNew: c.isNew }])
	);

	const [visibleColumns, setVisibleColumns] = useState<Set<string>>(() =>
		getColumnVisibilityFromConfig(loadGridConfig(), path, allIds, alwaysVisibleIds, columnDefaults)
	);

	const handleApply = (newVisible: Set<string>) => {
		setVisibleColumns(newVisible);
		const updated = updateColumnVisibilityInConfig(
			loadGridConfig(),
			path,
			newVisible,
			allIds,
			newColumnIds
		);
		saveGridConfig(updated);
	};

	return [visibleColumns, handleApply];
}
